import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Grid } from '@mui/material';
var _excluded = ["className", "component", "justify"];

var LayoutGrid = function LayoutGrid(_ref) {
  var className = _ref.className,
      component = _ref.component,
      justify = _ref.justify,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Grid, _extends({
    justifyContent: justify,
    component: component,
    className: className
  }, rest));
};

LayoutGrid.displayName = 'LayoutGrid';
export { LayoutGrid };